import { Component } from 'react';
import PropTypes from 'prop-types';
/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
export default class OptGroup extends Component {
}
OptGroup.propTypes = {
    label: PropTypes.string,
};
OptGroup.__PRO_OPT_GROUP = true;
